import React,{useState,useRef,useEffect}from 'react';
import Modal from 'jd-library/Modal';
import styles from './add-edit-product.scss';
const JustdialCatModal = props => {
    const [categoryScroll,setCategoryScroll] = useState(false);
    let categoryModalScrollRef = useRef(null);
    useEffect(() => {
		setTimeout(()=>{
			if(categoryModalScrollRef && categoryModalScrollRef.current){
				categoryModalScrollRef.current.addEventListener('scroll',handleCategoryScroll);
				return () => {
					categoryModalScrollRef.current.removeEventListener('scroll',handleCategoryScroll);
				};
			}
		},500)
    });
    const handleCategoryScroll = () =>{
		setCategoryScroll(categoryModalScrollRef.current && categoryModalScrollRef.current.scrollTop > 0)
	}
    return(
        <Modal
            settings= {{
                modalId: 'jdCatModal',
                variant: 'action',
                class: styles['jd-cat-list-modal']
            }}
            onHidden={() => props.showJDCatModal(false)} 
        >
            <Modal.CloseIcon iconClass = {styles['jd-cat-icon'] + ' icon-HDRcross'} />
            <div className = {styles['jd-cat-list-header']+" "+(categoryScroll ? styles['scrolled-header'] : '')}>
                {'Justdial Categories'}
            </div>
            <div className = {styles['jd-cat-list-body']} ref={categoryModalScrollRef}>
                {props.jdCatList.map((item) => {
                    return (<div className = {styles['jd-cat-list-item']}>{item}</div>);
                })}
            </div>
        </Modal>
    )
}
export default JustdialCatModal;